import { BarDatum } from "@nivo/bar";
import { RiskDistributionPoint } from "../RiskGovernanceOverview.types";

// One stacked bar per history point, keyed "1".."scale" (ascending so level 1 stacks at the bottom), with the
// bar's total alongside so the tooltip can show each segment's share. Zero-count levels are kept as explicit
// zeros — nivo needs every key on every bar for a stable stack.
export function buildRiskDistributionChartData(points: Array<RiskDistributionPoint>, scale: number): Array<BarDatum> {
    return points.map((point, index) => {
        const datum: BarDatum = { index };
        let total = 0;
        for (let level = 1; level <= scale; level++) {
            const count = point.countsByLevel[level - 1] ?? 0;
            datum[String(level)] = count;
            total += count;
        }
        datum.total = total;
        return datum;
    });
}

export function riskDistributionChartKeys(scale: number): Array<string> {
    return Array.from({ length: scale }, (_, index) => String(index + 1));
}
